import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import * as authSelectors from '../../shared/selectors/auth.selector';
import { UserPermissionGroup } from '../models/user-permission-group.model';
import { AccountTypes } from '../enums/account-type.enum';

@Injectable({
    providedIn: 'root'
})
export class NotConsumerGuard implements CanActivate {
    constructor(
        private store: Store<AppState>,
        private router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        this.store.select(authSelectors.getAccountTypeId)
            .subscribe((accountTypeId: AccountTypes) => {

                if (accountTypeId === AccountTypes.Consumer) {
                    this.router.navigate(['/order-guide']);
                    return;
                }
            });

        return true;
    }

}
